import { Route, DeepReadonly } from '../types';

import { RoutesId } from './routesId';

/** Configuration for the application routes */
export const ROUTES_CONFIG = {
  id: RoutesId.root,
  path: '',
  children: [
    {
      id: RoutesId.home,
      index: true,
    },
    {
      id: RoutesId.notFound,
      path: '*',
      authorizationIsRequired: false,
    },

    // auth
    {
      id: RoutesId.registration,
      path: 'registration',
      authorizationIsRequired: false,
    },
    {
      id: RoutesId.login,
      path: 'auth',
      authorizationIsRequired: false,
    },
    {
      id: RoutesId.loginByToken,
      path: 'auth/token',
      authorizationIsRequired: false,
    },
    {
      id: RoutesId.restorePassword,
      path: 'restore-password',
      authorizationIsRequired: false,
    },

    // onboarding
    {
      id: RoutesId.onboarding,
      path: 'onboarding',
    },
    {
      id: RoutesId.onboardingInfo,
      path: 'onboarding/info',
    },

    // user
    {
      id: RoutesId.changePassword,
      path: 'password',
    },

    // account
    {
      id: RoutesId.account,
      path: 'account',
      shouldAddToRouter: (_, client) => !!client?.isAccountOpened,
      children: [
        {
          id: RoutesId.orders,
          path: 'orders',
          children: [
            {
              id: RoutesId.order,
              path: ':orderId',
            },
            {
              id: RoutesId.createOrder,
              path: 'new',
            },
          ],
        },
        { id: RoutesId.documents, path: 'documents' },
      ],
    },

    // agreement
    {
      id: RoutesId.agreement,
      path: 'agreement',
    },
  ],
} as const satisfies DeepReadonly<Route>;
